<template>
  <div class="user_info_body">
    <div class="deco">
      <div class="user_info_form">
        <h4>기본 정보</h4>
        <v-button @handleClick="goToChangeUserInfo" text="사업자 변경 신청" class="btn06 corner"></v-button>
        <dl>
          <dt>사용자 유형</dt>
          <dd v-if="userInfo.businessType === 2">개인사업자</dd>
          <dd v-else>법인사업자</dd>
        </dl>
      </div>

      <div class="user_info_form user_info_form_bt">
        <h4>연락처</h4>
        <dl v-if="!isTelnoModify">
          <dt>전화번호</dt>
          <dd>{{ userInfo.telNo }}</dd>
          <dd class="bt">
            <v-button
              @handleClick="isTelnoModify = true"
              :disabled="isTelnoModify"
              text="수정"
              class="btn06"
            ></v-button>
          </dd>
        </dl>
        <tel-no-form v-else @cancel-click="isTelnoModify = false" formType="modify"></tel-no-form>

        <dl v-if="!isEmailModify">
          <dt>이메일</dt>
          <dd>{{ userInfo.businessEmail }}</dd>
          <dd class="bt">
            <v-button
              @handleClick="isEmailModify = true"
              :disabled="isEmailModify"
              text="수정"
              class="btn06"
            ></v-button>
          </dd>
        </dl>
        <email-form v-else @cancel-click="isEmailModify = false" formType="modify"></email-form>
      </div>

      <div class="user_info_form">
        <h4>사업자 정보</h4>
        <div class="btH4">
          <v-button @handleClick="modifyClick" text="수정하기" class="btn06"></v-button>
        </div>
        <div class="user_info_form_sub">
          <h5>업체정보</h5>
          <dl>
            <dt>업체(법인)명</dt>
            <dd>{{ userInfo.businessName }}</dd>
          </dl>
          <dl>
            <dt>사업자등록번호</dt>
            <dd>{{ userInfo.businessLicenseNumber }}</dd>
          </dl>
          <dl>
            <dt>대표자명</dt>
            <dd>{{ userInfo.businessOwnerName }}</dd>
          </dl>
          <dl>
            <dt>주소</dt>
            <dd>({{ userInfo.zipCode }}) {{ userInfo.address1 }} {{ userInfo.address2 }}</dd>
          </dl>
        </div>

        <div class="user_info_form_sub">
          <h5>지급 계좌</h5>
          <dl>
            <dt>계좌주</dt>
            <dd>{{ userInfo.accountOwnerName }}</dd>
          </dl>
          <dl>
            <dt>은행선택</dt>
            <dd>{{ userInfo.bankName }}</dd>
          </dl>
          <dl>
            <dt>계좌번호</dt>
            <dd>{{ userInfo.accountNo }}</dd>
          </dl>
        </div>
      </div>
      <div class="user_info_caution">
        <ul>
          <li>
            사업자 회원은 매월 1일에 전월까지 적립한 포인트가 최소 환전 가능 금액을 넘는 경우 자동으로 포인트 전환
            신청이 됩니다.
          </li>
          <li>포인트 전환 내역에 자동 신청된 내역이 매월 1일 생성됩니다.</li>
          <li>
            상세내역을 확인 후 확정된 금액에 대해서 25일까지 전자세금계산서를 보내주시면 익월 15일 수익이 지급됩니다.
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VButton from '@/components/atoms/VButton';
import TelNoForm from '@/components/modules/common/TelNoForm';
import EmailForm from '@/components/modules/common/EmailForm';

export default {
  components: {
    VButton,
    TelNoForm,
    EmailForm,
  },
  data() {
    return {
      isTelnoModify: false,
      isEmailModify: false,
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    modifyClick() {
      if (this.userInfo.status !== 2 || this.userInfo.status !== 3) {
        this.$router.replace({ name: 'UserInfoModify' });
      } else {
        this.openModal({
          type: 'alert',
          message:
            '아직 처리되지 않은 사업자 신청 내역이 있습니다. <br>처리 완료 후 정보 수정이  가능합니다. ​<br>처리 결과는 내정보&gt;사업자 처리 내역 에서 확인 하실 수 있습니다. ​',
          callback: () => {
            this.$router.replace({ name: 'UserInfoView' });
          },
        });
      }
    },
    goToChangeUserInfo() {
      return this.$router.replace({ name: 'UserInfoChange' });
    },
  },
};
</script>
<style lang="scss" scoped>
.user_info_view {
  .user_info_body {
    .deco {
      padding: 0 30px;
    }
  }
}
.btn06 {
  &.corner {
    position: absolute;
    top: 30px;
    right: 0;
  }
}
</style>
